import { Link as MuiLink } from '@mui/material'
import { ComponentProps, ForwardedRef, forwardRef } from 'react'
import { Link, NavLink } from 'react-router-dom'

import getIsMarketingPath, {
  pathToMarketingSiteBuilder,
} from '~/features/marketing/utils'
import { docsUrlBuilder, getIsDocsPath } from '~/utils/docs'

type TProps = {
  shouldUseNavLink?: boolean
  end?: boolean
} & Omit<ComponentProps<'a'>, 'href' | 'ref'> &
  Pick<ComponentProps<typeof Link>, 'to'>

function Component(
  { children, ...props }: TProps,
  ref: ForwardedRef<HTMLAnchorElement>,
) {
  const { to, shouldUseNavLink = false, end, ...linkProps } = props
  const pathname = typeof to === 'string' ? to : to.pathname

  const isMarketingPath = getIsMarketingPath({ pathname })
  const isDocsPath = getIsDocsPath(pathname)

  if (isMarketingPath || isDocsPath) {
    const href = isDocsPath
      ? docsUrlBuilder(pathname)
      : pathToMarketingSiteBuilder(pathname)

    return (
      <MuiLink
        ref={ref}
        {...linkProps}
        href={href}
        sx={{
          '&:hover': {
            color: 'inherit',
          },
        }}
      >
        {children}
      </MuiLink>
    )
  }

  if (shouldUseNavLink) {
    return (
      <NavLink ref={ref} to={to} end={end} {...linkProps}>
        {children}
      </NavLink>
    )
  }

  return (
    <Link ref={ref} to={to} {...linkProps}>
      {children}
    </Link>
  )
}

const MarketingLink = forwardRef(Component)

export default MarketingLink
